import SiteMessagesInstance from '../../components/site-messages'

export class StepConnectManually {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "connect_manually";
  title = "Connect to Temp Stick";

  template = `
  <div class="onboarding-step" data-for="connect_manually">

    <!-- Bluetooth: no QR code needed, the sensor is picked from a scan. Only
         shown when this build of the app has the Bluetooth bridge. -->
    <div class="onboarding-ble-manual" style="display: none;">

      <p class="onboarding-guide-instruction">
        Keep your Temp Stick in setup mode next to this device and search for it over <b>Bluetooth</b>.
      </p>

      <button type="button" class="button" data-for="connect_manually_ble_scan">
        Search with Bluetooth
      </button>

      <div class="onboarding-ble-devices"></div>

      <div class="text-divider">
        <div class="text-divider__text">OR</div>
      </div>

    </div>

    <p class="onboarding-guide-instruction">
      Go to the <b>WiFi settings</b> of this device and connect to the WiFi network named <b>Sensor Setup</b> and return
      to the app.
    </p>

    <p class="onboarding-guide-instruction-smaller">
      Your Temp Stick creates this temporary network so that it can connect directly with your device to finish setup.
    </p>

    <button type="button" class="button" data-for="connect_manually_connected">
      Open WiFi Settings
    </button>

    <div class="onboarding-guide-instruction-smaller">
      <b>Note:</b> The Sensor Setup network name will also include your sensor ID.
      <br />
      <div style="margin-top: 7px;">For example: "Sensor Setup 1234567"</div>
    </div>

    <ul class="onboarding-guide-instruction-smaller text--semibold">
      <li class="text--blue">Once you are connected to the Sensor Setup network return here and we'll automatically go to the next step.</li>

    ${navigator.userAgent.match(/ios/i) ? `
      <li class="onboarding-guide-instruction-smaller text--semibold text--grey">
        * Select "Keep Trying WiFi" or "Stay Connected" if you get the "no internet" warning message while connecting to the
        WiFi network. Don't use mobile data.
      </li>
    ` : `
      <li class="onboarding-guide-instruction-smaller text--semibold text--grey">
        Ignore the "no internet" warning message while connecting to the WiFi network. Select "Stay Connected" if
        prompted. Don't use mobile data.
      </li>
    `}

    <li class="text--blue">
      To save batteries, the sensor may go to sleep after inactivity, if the light stops blinking please reinsert the
      batteries.
    </li>

    </ul>



  </div>
  `;

  onBack = () => {
    this.onboarding.hideBackButton();

    if(this.onboarding.sensor_version === 'v2') {
      this.onboarding.goToStep('start_app');
    } else {
      this.onboarding.goToStep('guide_select_model');
    }

  }

  onActivate = () => {
    this.onboarding.showBackButton();

    // Bluetooth is offered when the app can do it and it isn't switched off
    // for testing (?transport=wifi).
    const offerBle = !!this.onboarding.bleBridge() && this.onboarding.transportPreference() !== 'wifi';
    this.$bleManual.toggle(offerBle);
    this.$bleDevices.empty();
    this.$bleScanBtn.prop('disabled', false).text('Search with Bluetooth');

    // start the heartbeat
    this.onboarding.Temp_Stick_Heartbeat();

    this.onboarding.manual_connect = true;
    this.onboarding.attemptToConnect();
  }

  bindActions = () => {
    this.$connectedManuallyConfirmationBtn = $(this.onboarding.container).find('.button[data-for="connect_manually_connected"]');
    this.$bleManual = $(this.onboarding.container).find('.onboarding-step[data-for="connect_manually"] .onboarding-ble-manual');
    this.$bleScanBtn = $(this.onboarding.container).find('button[data-for="connect_manually_ble_scan"]');
    this.$bleDevices = $(this.onboarding.container).find('.onboarding-step[data-for="connect_manually"] .onboarding-ble-devices');

    this.$connectedManuallyConfirmationBtn.on('click', () => {

      try {

        window.gonative.nativebridge.manualWifiConnect({
          callback: data => {}
        });

      } catch (e) {
        SiteMessagesInstance.addMessage('error', 'Failed to open the settings page for your device');
        SiteMessagesInstance.displayMessages();
      }

    });

    this.$bleScanBtn.on('click', () => this.scanBle());

    this.$bleDevices.on('click', '.onboarding-ble-devices__device', e => {
      const address = e.currentTarget.dataset.address;
      const sensorId = e.currentTarget.dataset.sensorId || '';
      this.connectBle(address, sensorId);
    });

  }

  async scanBle() {

    // A browser bridge has no scan to list: its connect() opens the
    // browser's own chooser, so go straight there.
    const bridge = this.onboarding.bleBridge();
    if (bridge && bridge.chooser) {
      this.connectBle('', '');
      return;
    }

    this.$bleScanBtn.prop('disabled', true).text('Searching...');
    this.$bleDevices.html('<div class="onboarding-ble-devices__note">Looking for Temp Sticks in setup mode...</div>');

    const res = await this.onboarding.Temp_Stick_Scan_Ble();

    this.$bleScanBtn.prop('disabled', false).text('Search Again');

    if (!res.success) {
      this.$bleDevices.empty();
      SiteMessagesInstance.addMessage('error', this.bleFailureMessage(res));
      SiteMessagesInstance.displayMessages();
      return;
    }

    const devices = Array.isArray(res.devices) ? res.devices : [];

    if (devices.length === 0) {
      this.$bleDevices.html(`
        <div class="onboarding-ble-devices__note">
          No Temp Sticks found over Bluetooth. Make sure the sensor is in setup mode and close by, then search again.
        </div>
      `);
      return;
    }

    devices.sort((a, b) => (b.rssi || -999) - (a.rssi || -999));

    this.$bleDevices.html(devices.map(device => {

      const label = device.sensorId ? `Temp Stick ${device.sensorId}` : (device.name || 'Temp Stick');
      const address = String(device.address || '');
      const sensorId = String(device.sensorId || '');

      return `
        <button type="button" class="onboarding-ble-devices__device" data-address="${address}" data-sensor-id="${sensorId}">
          <div class="onboarding-ble-devices__device-name">${label}</div>
          <div class="onboarding-ble-devices__device-signal">${this.signalLabel(device.rssi)}</div>
        </button>
      `;

    }).join(''));

  }

  async connectBle(address, sensorId) {

    this.$bleDevices.find('.onboarding-ble-devices__device').prop('disabled', true);
    this.$bleDevices.find(`.onboarding-ble-devices__device[data-address="${address}"]`).addClass('is-active');

    const res = await this.onboarding.Temp_Stick_Connect_Ble({ address, sensorId, timeoutMs: 12000 });

    if (!res.success) {
      this.$bleDevices.find('.onboarding-ble-devices__device').prop('disabled', false).removeClass('is-active');
      if (res.code !== 'CANCELLED') {
        SiteMessagesInstance.addMessage('error', this.bleFailureMessage(res));
        SiteMessagesInstance.displayMessages();
      }
      return;
    }

    // From here the flow is the same as after a QR scan: the heartbeat (already
    // running for the manual path) picks the sensor up over the new link.
    this.onboarding.sensorId = res.sensorId || sensorId;
    this.onboarding.manual_connect = false;
    this.onboarding.goToStep('attempt_to_connect');

  }

  bleFailureMessage(res) {

    switch (res && res.code) {
      case 'BT_OFF':
        return 'Bluetooth is turned off on this device. Turn it on and try again, or connect through the Sensor Setup WiFi network.';
      case 'PERMISSION':
        return "The app doesn't have Bluetooth permission. Allow it in your device settings and try again.";
      case 'LOCATION_OFF':
        return 'Location services need to be on for Bluetooth scanning on this version of Android.';
      case 'UNAVAILABLE':
        return "This device can't use Bluetooth to set up a Temp Stick. Use the Sensor Setup WiFi network instead.";
      default:
        return (res && res.message) ? res.message : "We couldn't connect over Bluetooth, please try again.";
    }

  }

  signalLabel(rssi) {

    const value = parseInt(rssi, 10);

    if (isNaN(value)) {
      return '';
    }

    if (value >= -60) {
      return 'Strong signal';
    }

    if (value >= -75) {
      return 'Good signal';
    }

    return 'Weak signal';

  }

}
